import { $t } from '@/i18n';
import { defineComponent } from '@vue/composition-api';
import AIPageDiff from '@/components/version/aiPageDiff';
/**
 * AI 冲突已解决 / 无冲突合并视图
 * 复用版本变更的 AIPageDiff，按 mainBranch 展示文件级 Diff
 *
 * 必须填满父级可用高度（h-full），不能用 calc(100vh-*)，
 * 否则会撑破 editor_wrap_right，导致外层滚动抢走左侧目录滚动。
 */
export default defineComponent({
    name: 'AIConflictResolvedView',
    props: {
        originalData: {
            type: Object,
            default: () => ({}),
        },
        modifiedData: {
            type: Object,
            default: () => ({}),
        },
        currentBranch: {
            type: String,
            default: '',
        },
        mergeBranch: {
            type: String,
            default: '',
        },
    },
    render() {
        return (<div class="h-full min-h-0 w-full overflow-hidden">
        <AIPageDiff originalData={this.originalData} modifiedData={this.modifiedData} preTitle={`${$t('k_5f4086f5')}${this.currentBranch}`} nextTitle={`${$t('k_abcc76ad')}${this.mergeBranch}`}/>
      </div>);
    },
});
